import { getStaticContentService } from '../services/services';

const staticContent = {};
let staticContentRequest = null;

export const loadStaticContent = async () => {
  if (staticContentRequest) return staticContentRequest;

  staticContentRequest = getStaticContentService()
    .then(response => {
      Object.keys(staticContent).forEach(key => delete staticContent[key]);
      Object.assign(staticContent, response.data);
      return staticContent;
    })
    .catch(error => {
      staticContentRequest = null;
      throw error;
    });

  return staticContentRequest;
};

export default staticContent;
